module.exports = __webpack_public_path__ + "img/TransactionHistory.652bafbe.svg";